const ROUTES = {
  TRADE: 'https://swap.dex.qie.digital/swap',
  BRIDGE:'https://bridge.qie.digital/bridge',
  // TRADE: '/stake',
  STAKE: '/stake',
  TOKEN_CREATOR: '/token-creator',
  HOME: '/',
  FAQ: '/faq',
  DISCLAIMER: '/disclaimer',
  TERMS: '/terms',
  POLICY: '/policy',
  LIQUIDITY_REMOVE: '/swap/liquidity-remove',
  ALL_SWAPS: '#',
  DOCS: 'https://qiedex.qie.digital/',
  QI_BLOCKCHAIN: 'https://mainnet.qie.digital/',
};

export default ROUTES;
